import constants from './constants';

const initState = {
  invertersList: null,
  offset: 0,
  limit: 40,
  count: null,
  createEditValues: null,
  search: '',
  isEditDefault: false,
  idsInDeleting: [],
  listDataModelInverters: [],
  createNewInverter: {
    code: '',
    client: '',
    solar_capacity: 0,
    storage_capacity: 0,
    inverter_capacity: 0,
    solar_panel_number: 0,
    battery_cycles: 0,
    battery_voltage: 0,
    battery_type: '',
    location: '',
    address: '',
    latitude: 0,
    longitude: 0,
    characteristics: {},
    device_id: '',
    inverter_model_id: '',
  },
  inverterIdToEdit: null,
  saveState: {
    inverter: false,
    device: false,
  },
};

function invertersReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SET_INVERTER_EDIT_DATA:
      return {
        ...state,
        createNewInverter: payload,
      };

    case constants.SET_SABE_STATE:
      return {
        ...state,
        saveState: payload,
      };

    case constants.SET_INVERTER_ID_TO_EDIT:
      return {
        ...state,
        inverterIdToEdit: payload,
      };

    case constants.SET_GET_MODEL_INVERTERS:
      return {
        ...state,
        listDataModelInverters: payload,
      };

    case constants.SET_CREATE_EDIT_DEVICES:
      return {
        ...state,
        createNewInverter: payload,
      };

    case constants.SET_IS_EDIT_DEFAULT:
      return {
        ...state,
        isEditDefault: payload,
      };

    case constants.RESET_ALARMS:
      return {
        ...state,
        invertersList: null,
        offset: 0,
        count: null,
      };

    case constants.SET_SEARCH:
      return {
        ...state,
        search: payload,
      };

    case constants.RESET_OFFSET:
      return {
        ...state,
        offset: 0,
        count: null,
      };

    case constants.SET_ALARMS_LIST:
      return {
        ...state,
        invertersList: payload.invertersList,
        offset: payload.offset,
        count: payload.count,
      };

    case constants.EDIT_ALARM:
      return {
        ...state,
        invertersList: payload,
      };

    case constants.START_DELETING_ALARM:
      return {
        ...state,
        idsInDeleting: payload,
      };

    case constants.ADD_ALARM:
    case constants.DELETE_ALARM:
      return {
        ...state,
        invertersList: payload.invertersList,
        count: payload.count,
        idsInDeleting:
          payload.idsInDeleting !== undefined ? payload.idsInDeleting : state.idsInDeleting,
      };

    case constants.SET_ALARM_COUNT:
      return {
        ...state,
        count: payload,
      };

    case constants.SET_CREATE_EDIT_VALUES:
    case constants.ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS:
    case constants.REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS:
    case constants.ADD_CREATE_EDIT_VALUES_OR_CONDITION:
    case constants.REMOVE_CREATE_EDIT_VALUES_OR_CONDITION:
    case constants.CHANGE_CREATE_EDIT_VALUES_OR_CONDITION:
    case constants.ADD_CREATE_EDIT_VALUES_ACTION:
    case constants.REMOVE_CREATE_EDIT_VALUES_ACTION:
    case constants.CHANGE_CREATE_EDIT_VALUES_ACTION:
      return {
        ...state,
        createEditValues: payload,
      };

    default:
      return state;

  }

}

export default invertersReducer;
